import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DeeplinksService {
  deeplink$: BehaviorSubject<string>;
  assetAdminUrl$: BehaviorSubject<string>;

  constructor(private apiService: ApiService) {
    this.deeplink$ = new BehaviorSubject<string>('');
    this.assetAdminUrl$ = new BehaviorSubject<string>('');
    this.setAssetAdminUrl();
    this.setMarketAdminUrl();
  }

  async setMarketAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/markets/');
      this.deeplink$.next(url + '/create');
    } catch (err) {
      console.log('Could not load market admin url.', err);
    }
  }

  async setAssetAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/assets/');
      this.assetAdminUrl$.next(url);
    } catch (err) {
      console.log('Could not load asset admin url.', err);
    }  
  }

  getAssetAdminUrl() {
    return this.assetAdminUrl$.asObservable();
  }
}
